export default __webpack_public_path__ + "static/media/au-aboriginal.3fa13ab6.svg";